// Blocat la programari online (2.0.7, clients.web_blocked - salonul il pune din fisa clientului in
// aplicatie). Mesajul INLOCUIESTE formularul pasului, fara buton inainte (hotararea userului, 2 oct
// 2026): dupa pasul cu telefonul (authPhone, ruta checkBlocked) si, pentru cine nu trece prin el, la
// Finalize (confirm, 403 cu reason client_blocked din AppointmentController::store).
//
// Textul vine de la server, in limba paginii (booking.client_blocked); fara el, cheia din fisierele
// de limba, apoi un text englezesc de rezerva - niciodata cheia bruta.
import {t} from '../i18n';
import {stopHoldHeartbeat} from './slotHold.js';

export const BLOCKED_REASON = 'client_blocked';

function fallbackText() {
    const v = t(BLOCKED_REASON);
    return v && v !== BLOCKED_REASON ? v : 'Online booking is not available at the moment.';
}

/**
 * @param {Function} $        jQuery-ul widgetului
 * @param {object}   $host    unde se pune mesajul (pasul curent)
 * @param {object}   $parts   ce dispare din pas (antetul si formularul); butonul de inchidere ramane
 * @param {string}   [message] textul de la server
 */
export function showBlockedNotice($, $host, $parts, message) {
    // ora tinuta la alegere nu mai e a nimanui: o lasam sa expire, nu o mai reinnoim
    stopHoldHeartbeat();
    const $notice = $('<div class="bw-blocked-notice" role="status"><p class="bw-blocked-text"></p></div>');
    $notice.find('.bw-blocked-text').text(message || fallbackText());
    $parts.remove();
    $host.append($notice);
}
